import React, { useState } from 'react';
import { 
  Box, 
  Typography, 
  Tabs, 
  Tab, 
  Paper 
} from '@mui/material';
import EventSeatIcon from '@mui/icons-material/EventSeat';
import ListAltIcon from '@mui/icons-material/ListAlt';
import SeatGenerationTool from './SeatGenerationTool';
import SeatingsListAdmin from './SeatingsListAdmin';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`seating-tabpanel-${index}`}
      aria-labelledby={`seating-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `seating-tab-${index}`,
    'aria-controls': `seating-tabpanel-${index}`,
  };
}

const SeatingAdmin: React.FC = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs 
          value={tabValue} 
          onChange={handleTabChange} 
          aria-label="seating management tabs"
          textColor="primary"
          indicatorColor="primary"
        >
          <Tab 
            icon={<EventSeatIcon fontSize="small" />} 
            iconPosition="start" 
            label="Generate Seating" 
            {...a11yProps(0)} 
          />
          <Tab 
            icon={<ListAltIcon fontSize="small" />} 
            iconPosition="start" 
            label="Saved Seating Plans" 
            {...a11yProps(1)} 
          />
        </Tabs>
      </Box>

      <TabPanel value={tabValue} index={0}>
        <SeatGenerationTool onPlanSaved={() => setTabValue(1)} />
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <SeatingsListAdmin />
      </TabPanel>
    </>
  );
};

export default SeatingAdmin;